import { type FC, useContext } from 'react'
import { BADGE_CHIP_CLASSES, badgeClasses, BADGES_CLASSES, badgeParts } from './badge'
import { type Badge } from './emailTemplateTypes'
import { VariableLabelsContext } from './VariableLabelsContext'

export interface BadgeViewProps {
  badge: Badge
}

export const BadgeView: FC<BadgeViewProps> = ({ badge }) => {
  const labels = useContext(VariableLabelsContext)
  return (
    <span className={badgeClasses(badge)} data-email-badge={badge.variant}>
      {badgeParts(badge, labels).map((part, index) =>
        part.kind === 'text' ? (
          <span key={`${index}-text`}>{part.text}</span>
        ) : (
          <span key={`${index}-chip`} className={BADGE_CHIP_CLASSES}>
            {part.label}
          </span>
        ),
      )}
    </span>
  )
}

export interface BadgesViewProps {
  badges: Badge[]
}

export const BadgesView: FC<BadgesViewProps> = ({ badges }) => (
  <span className={BADGES_CLASSES} data-email-badges=''>
    {badges.map((badge, index) => (
      <BadgeView key={index} badge={badge} />
    ))}
  </span>
)
